import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import About from '../components/About'
import './style.css'

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <BrowserRouter>
      <div>
        <About/>
      </div>
    </BrowserRouter>
  )
}

